import { Directive, Input, HostListener } from '@angular/core';
import { ModalController } from 'ionic-angular';
import { AlertService } from '../../providers/alert.service';
import { NormalReportService } from '../../services/normalreport.service';
import { LoaddingService } from '../../providers/loadding.service';
import * as $ from 'jquery';
//撤单指令
//TQQ 2017-02-22
@Directive({
    selector: '[revocation]',
    providers: [NormalReportService]
})
export class RevocationDirective {
    constructor(
        private modalctrl: ModalController,
        private alert: AlertService,
        private loadding: LoaddingService,
        private normalreport: NormalReportService
    ) { }
    @Input("revocation") Data: any;
    @HostListener('click') onMouseEnter() {
        if (!this.Data) {
            throw new Error("miss Data");
        } else if (this.Data.ischase) {
            if (!this.Data.ID) {
                throw new Error("miss options: ID");
            }
            this.allRevocation(this.Data);
        } else {
            if (!this.Data.IssueId) {
                throw new Error("miss options: IssueId");
            }
            this.normalRevocation(this.Data);
        }
    }

    //常规撤单
    //TQQ 2017-02-22
    normalRevocation(data) {
        let issueId = data.IssueId;
        let modeType = Number(data.ModeType) || 0;
        this.alert.showConfirm("确定要撤销该订单？", () => {
            let load = this.loadding.showLoding("正在撤单...");
            this.normalreport.revocationCommand(modeType, issueId).then(s => {
                if (s.Result) {
                    this.alert.showAlert("操作成功， 已撤单");
                    if ($.isFunction(data.callback)) {
                        data.callback(s);
                    }
                } else {
                    this.alert.showAlert(s.Error);
                }
                this.loadding.closeLoading(load);
            }).catch(() => {
                this.loadding.closeLoading(load);
            });

        }, "确认消息");
    }

    //全部撤单
    //TQQ 2017-02-23
    allRevocation(data) {
        let bettingId = data.ID;
        let modeType = Number(data.ModeType) || 0;
        this.alert.showConfirm("确定要撤销该订单所有未开奖的期数？", () => {
            let load = this.loadding.showLoding("正在撤单...");
            this.normalreport.allrevocationCommand(modeType, bettingId).then(s => {
                if (s.Result) {
                    this.alert.showAlert("操作成功， 已撤单");
                    if ($.isFunction(data.callback)) {
                        data.callback(s);
                    }
                } else {
                    this.alert.showAlert(s.Error);
                }
                this.loadding.closeLoading(load);
            }).catch(() => {
                this.loadding.closeLoading(load);
            });
        }, "确认消息");
    }

}




// WEBPACK FOOTER //
// ./src/dires/revocation/revocation.directive.ts